<template>
    <div id="gdpr-main-form-container">
      <div id="gdpr-main-text">
        <h2>Molimo da prilagodite <span class="gdpr-color-text">svoju saglasnost</span>.</h2>
      </div>
      <!-- Form -->
      <div id="gdpr-form">
        <form>
          <!-- FORM NAME -->
          <div id="gdpr-form-name">
            <h4 v-html="$store.state.texts.titles.checkNameSurnameTitle"></h4>
            <p v-html="$store.state.texts.titles.checkNameSurname"></p>
            <!-- NAZIV DROPDOWN -->
            <div class="form-group row">
              <label for="gdpr-gender" class="col-sm-3 col-form-label label-margin-top" v-html="$store.state.texts.fields.userGender"></label>
              <div class="col-sm-9 custom-select">
                <select id="user-gender" class="text-field" v-model="$store.state.form.user.title" @change="$store.state.dropdowns.gender.validation = true" :class="{isInvalid: !$store.state.dropdowns.gender.validation && $store.state.submitted}">
                  <option disabled selected="selected">{{ $store.state.texts.user.gender }}</option>
                  <option :key="index" v-for="(title, index) in $store.state.dropdowns.gender.titles">{{ title }}</option>
                </select>
                <span class="selectedValue" v-if="$store.state.form.user.title === ''" v-html="$store.state.texts.user.gender"></span>
              </div>
              <span class="error-message" v-if="!$store.state.dropdowns.gender.validation && $store.state.submitted" v-html="$store.state.texts.fields.genderErrorMsg"></span>
            </div>
            <!-- IME FIELD -->
            <div class="form-group row">
              <label for="gdpr-ime" class="col-sm-3 col-form-label label-margin-top" v-html="$store.state.texts.fields.userName"></label>
              <div class="col-sm-9">
                <input 
                  type="text" 
                  id="gdpr-ime" 
                  class="form-control text-field"
                  :class="{isInvalid: $v.ime.$error}"
                  aria-describedby="emailHelp" 
                  :placeholder="$store.state.texts.fields.placeholderName"
                  v-model="$store.state.ime"
                  @blur="$v.ime.$touch()">
              </div>
              <span class="error-message" v-if="$v.ime.$error" v-html="$store.state.texts.fields.nameErrorMsg"></span>
            </div>
            <!-- PRIIMEK FIELD -->
            <div class="form-group row">
              <label for="gdpr-priimek" class="col-sm-3 col-form-label label-margin-top" v-html="$store.state.texts.fields.userSurname"></label>
              <div class="col-sm-9">
                <input 
                  type="text" 
                  class="form-control text-field"
                  :class="{isInvalid: $v.priimek.$error}" 
                  id="gdpr-priimek" 
                  :placeholder="$store.state.texts.fields.placeholderSurname"
                  v-model="$store.state.priimek"
                  @blur="$v.priimek.$touch()">
              </div>
              <span class="error-message" v-if="$v.priimek.$error" v-html="$store.state.texts.fields.surnameErrorMsg"></span>
            </div>
            <!-- ULICA HIŠNA ŠT FIELD -->
            <div class="form-group row">
              <label for="gdpr-street" class="col-sm-3 col-form-label label-margin-top" v-html="$store.state.texts.fields.userStreet"></label>
              <div class="col-sm-9">
                <input 
                  type="text" 
                  class="form-control text-field"
                  :class="{isInvalid: $store.state.ulicaError || $v.street.$error}" 
                  id="gdpr-street" 
                  :placeholder="$store.state.texts.fields.placeholderStreet"
                  v-model="$store.state.street"
                  @blur="$v.street.$touch() || validateStreet()">
              </div>
              <span class="error-message" v-if="$store.state.ulicaError || $v.street.$error" v-html="$store.state.texts.fields.streetErrorMsg"></span>
            </div>
            <!-- POŠTNA ŠTEVILKA -->
            <div class="form-group row">
              <label for="gdpr-post-number" class="col-sm-3 col-form-label label-margin-top" v-html="$store.state.texts.fields.userPostNumber"></label>
              <div class="col-sm-9">
                <input 
                  type="text" 
                  class="form-control text-field"
                  :class="{isInvalid: $store.state.postnaStError || $v.postNumber.$error}" 
                  id="gdpr-post-number" 
                  :placeholder="$store.state.texts.fields.placeholderPostNumber"
                  v-model="$store.state.postNumber"
                  @blur="$v.postNumber.$touch() || validatePostNumber()">
              </div>
              <span class="error-message" v-if="$store.state.postnaStError || $v.postNumber.$error" v-html="$store.state.texts.fields.postNumberErrorMsg"></span>
            </div>
            <!-- POŠTA -->
            <div class="form-group row">
              <label for="gdpr-post-office" class="col-sm-3 col-form-label label-margin-top" v-html="$store.state.texts.fields.userPostOffice"></label>
              <div class="col-sm-9">
                <input 
                  type="text" 
                  class="form-control text-field"
                  :class="{isInvalid: $store.state.postaError || $v.postOffice.$error}" 
                  id="gdpr-post-office" 
                  :placeholder="$store.state.texts.fields.placeholderPostOffice"
                  v-model="$store.state.postOffice"
                  @blur="$v.postOffice.$touch() || validatePostOffice()">
              </div>
              <span class="error-message" v-if="$store.state.postaError || $v.postOffice.$error" v-html="$store.state.texts.fields.postOfficeErrorMsg"></span>
            </div>
            <!-- TELEFON -->
            <div class="form-group row">
              <label for="gdpr-telephone" class="col-sm-3 col-form-label label-margin-top" v-html="$store.state.texts.fields.userTelephone"></label>
              <div class="col-sm-9">
                <input 
                  type="text" 
                  class="form-control text-field"
                  :class="{isInvalid: $store.state.telephoneError || $store.state.smsError}"
                  id="gdpr-telephone" 
                  :placeholder="$store.state.texts.fields.placeholderTelephone"
                  v-model="$store.state.telephone"
                  @blur="validatePhone(), validateSms()">
              </div>
              <span class="error-message" v-if="$store.state.telephoneError || $store.state.smsError" v-html="$store.state.texts.fields.telephoneErrorMsg"></span>
            </div>
            <!-- EMAIL FIELD-->
            <div class="form-group row">
              <label for="gdpr-email" class="col-sm-3 col-form-label label-margin-top" v-html="$store.state.texts.fields.userEmail"></label>
              <div class="col-sm-9">
                <input 
                  type="email" 
                  class="form-control text-field"
                  :class="{isInvalid: $v.email.$error && ($store.state.checkboxes.ePosta.value || $store.state.buttons.obvescanjeEposta.value)}"
                  id="gdpr-email" 
                  :placeholder="$store.state.texts.fields.placeholderEmail"
                  v-model="$store.state.email"
                  @blur="$v.email.$touch()">
              </div>
              <span class="error-message" v-if="$v.email.$error && ($store.state.checkboxes.ePosta.value || $store.state.buttons.obvescanjeEposta.value)" v-html="$store.state.texts.fields.emailErrorMsg"></span>
            </div>
          </div>
          <!-- END OF FORM NAME -->
          <hr class="hr-line  hr-line--bottom"/>
          <div>
            <h4 style="font-weight:700;" v-html="$store.state.texts.titles.landingPageSubtitleFirst"></h4>
            <p v-html="$store.state.texts.gdpr.landingPageIntro"></p>
            <p style="font-weight:bold" v-html="$store.state.texts.gdpr.landingPageIntroSubtext"></p>
          </div>
          <!-- Form Other Information -->
          <div id="gdpr-other-information" ontouchstart="">
            <p v-html="$store.state.texts.titles.checkChannels"></p>
            <!-- NE ŽELIM SPOROČIL -->
            <div class="form-group row">
              <!-- Buttons -->
              <div>
                <div class="form-check form-check-inline col-sm-11 col-sm-offset-1">
                  <label class="form-check-label" for="gdpr-sporocila" style="font-weight:normal">NE ŽELIM NIKAKVE PORUKE
                    <input 
                      class="form-check-input" 
                      type="checkbox" 
                      name="gdpr-sporocila" 
                      id="gdpr-sporocila"
                      v-model="$store.state.checkboxes.sporocila.value"
                     @change="$store.state.form.gdpr.sporocila = $store.state.checkboxes.sporocila.value, checkSporocila()">
                    <span class="gdpr-radio-button"></span>
                  </label>
                  <div style="cursor: text;">
                    <p v-html="$store.state.texts.gdpr.landingPageIntroConsentText"></p>
                  </div>
                </div>
              </div>
            </div>
            <!-- END OF EMAIL INFO -->
          </div>
          <div>
            <h4 style="text-transform:uppercase;" v-html="$store.state.texts.titles.landingPageSubtitleSecond"></h4>
            <p v-html="$store.state.texts.gdpr.landingSubtitlePageIntro"></p> 
          </div>
          <!-- Form Other Information -->
          <div id="gdpr-channels" ontouchstart="">
            <p v-html="$store.state.texts.titles.checkChannels"></p>
            <!-- NAKUP VOZILA INFO -->
            <div class="form-group row">
              <label for="gdpr-obvescanjeEposta" class="col-sm-8 col-form-label-first-channels">E-adresa</label>
              <!-- Buttons -->
              <div>
                <div class="form-check form-check-inline col-sm-2">
                <label class="form-check-label" for="gdpr-obvescanjeEposta-da">Da
                  <input 
                      class="form-check-input"
                      type="radio" 
                      name="gdpr-obvescanjeEposta" 
                      id="gdpr-obvescanjeEposta-da" 
                      v-model="$store.state.form.gdpr.obvescanjeEposta"
                      :value="true"
                      :disabled="$store.state.checkboxes.sporocila.value"
                      @change="$store.state.buttons.obvescanjeEposta.value = true, $store.state.buttons.obvescanjeEposta.error = false, $v.email.$touch(), checkFields()">
                  <span class="gdpr-radio-button" :class="{isInvalid: $store.state.buttons.obvescanjeEposta.error}"></span>
                </label>
                </div>
                <div class="form-check form-check-inline col-sm-2">
                  <label class="form-check-label" for="gdpr-obvescanjeEposta-ne">Ne
                    <input 
                      class="form-check-input" 
                      type="radio" 
                      name="gdpr-obvescanjeEposta" 
                      id="gdpr-obvescanjeEposta-ne"
                      v-model="$store.state.form.gdpr.obvescanjeEposta" 
                      :value="false"
                      :disabled="$store.state.checkboxes.sporocila.value"
                      @change="$store.state.buttons.obvescanjeEposta.value = false, $store.state.buttons.obvescanjeEposta.error = false, $v.email.$touch(), checkFields()">
                    <span class="gdpr-radio-button" :class="{isInvalid: $store.state.buttons.obvescanjeEposta.error}"></span>
                  </label>
                </div>
              </div>
              <span class="btn-error-message" v-if="$store.state.buttons.obvescanjeEposta.error" v-html="$store.state.texts.channels.errorMsg"></span>
            </div>
            <!-- END OF EMAIL INFO -->
            <!-- POPRODAJNI IZDELKI INFO -->
            <div class="form-group row">
              <label for="gdpr-obvescanjeSMS" class="col-sm-8 col-form-label-first-channels">SMS</label>
              <!-- Buttons -->
              <div class="form-check form-check-inline col-sm-2">
                <label class="form-check-label" for="gdpr-obvescanjeSMS-da">Da
                  <input 
                    class="form-check-input"
                    type="radio"
                    name="gdpr-obvescanjeSMS"
                    id="gdpr-obvescanjeSMS-da"
                    v-model="$store.state.form.gdpr.obvescanjeSMS"
                    :value="true"
                    :disabled="$store.state.checkboxes.sporocila.value"
                    @change="$store.state.buttons.obvescanjeSMS.value = true, $store.state.buttons.obvescanjeSMS.error = false, checkFields()">
                  <span class="gdpr-radio-button" :class="{isInvalid: $store.state.buttons.obvescanjeSMS.error}"></span>
                </label>
              </div>
              <div class="form-check form-check-inline col-sm-2">
                <label class="form-check-label" for="gdpr-obvescanjeSMS-ne">Ne
                  <input 
                    class="form-check-input" 
                    type="radio" 
                    name="gdpr-obvescanjeSMS" 
                    id="gdpr-obvescanjeSMS-ne"
                    v-model="$store.state.form.gdpr.obvescanjeSMS"
                    :value="false"
                    :disabled="$store.state.checkboxes.sporocila.value"
                    @change="$store.state.buttons.obvescanjeSMS.value = false, $store.state.buttons.obvescanjeSMS.error = false, checkFields()">
                  <span class="gdpr-radio-button" :class="{isInvalid: $store.state.buttons.obvescanjeSMS.error}"></span>
                </label>
              </div>
              <!-- End of buttons -->
              <span class="btn-error-message" v-if="$store.state.buttons.obvescanjeSMS.error" v-html="$store.state.texts.channels.errorMsg"></span>
            </div>
            <!-- END OF TISKANA POŠTA -->
            <!-- PERSONALIZATION INFO -->
            <div class="form-group row">
              <label for="gdpr-obvescanjeTelefon" class="col-sm-8 col-form-label-first-channels">Telefon</label>
              <!-- Buttons -->
              <div class="form-check form-check-inline col-sm-2">
                <label class="form-check-label" for="gdpr-obvescanjeTelefon-da">Da
                  <input 
                    class="form-check-input" 
                    type="radio" 
                    name="gdpr-obvescanjeTelefon" 
                    id="gdpr-obvescanjeTelefon-da"
                    v-model="$store.state.form.gdpr.obvescanjeTelefon"
                    :value="true"
                    :disabled="$store.state.checkboxes.sporocila.value"
                    @change="$store.state.buttons.obvescanjeTelefon.value = true, $store.state.buttons.obvescanjeTelefon.error = false, checkFields()">
                  <span class="gdpr-radio-button" :class="{isInvalid: $store.state.buttons.obvescanjeTelefon.error}"></span>
                </label>
              </div>
              <div class="form-check form-check-inline col-sm-2">
                <label class="form-check-label" for="gdpr-obvescanjeTelefon-ne">Ne
                  <input 
                    class="form-check-input" 
                    type="radio" 
                    name="gdpr-obvescanjeTelefon" 
                    id="gdpr-obvescanjeTelefon-ne"
                    v-model="$store.state.form.gdpr.obvescanjeTelefon"
                    :value="false"
                    :disabled="$store.state.checkboxes.sporocila.value"
                    @change="$store.state.buttons.obvescanjeTelefon.value = false, $store.state.buttons.obvescanjeTelefon.error = false, checkFields()">
                  <span class="gdpr-radio-button" :class="{isInvalid: $store.state.buttons.obvescanjeTelefon.error}"></span>
                </label>
              </div>
              <span class="btn-error-message" v-if="$store.state.buttons.obvescanjeTelefon.error" v-html="$store.state.texts.channels.errorMsg"></span>
            </div>
            <!-- ENEWS CHANEL -->
            <div class="form-group row">
              <label for="gdpr-obvescanePosta" class="col-sm-8 col-form-label-first-channels">Obična pošta</label>
              <!-- Buttons -->
              <div class="form-check form-check-inline col-sm-2">
                <label class="form-check-label" for="gdpr-obvescanePosta-da">Da
                  <input 
                    class="form-check-input" 
                    type="radio" 
                    name="gdpr-obvescanePosta" 
                    id="gdpr-obvescanePosta-da"
                    v-model="$store.state.form.gdpr.obvescanePosta"
                    :value="true"
                    :disabled="$store.state.checkboxes.sporocila.value"
                    @change="$store.state.buttons.obvescanePosta.value = true, $store.state.buttons.obvescanePosta.error = false, checkFields()">
                  <span class="gdpr-radio-button" :class="{isInvalid: $store.state.buttons.obvescanePosta.error}"></span>
                </label>
              </div>
              <div class="form-check form-check-inline col-sm-2">
                <label class="form-check-label" for="gdpr-obvescanePosta-ne">Ne
                  <input 
                    class="form-check-input" 
                    type="radio"
                    name="gdpr-obvescanePosta"
                    id="gdpr-obvescanePosta-ne"
                    v-model="$store.state.form.gdpr.obvescanePosta"
                    :value="false"
                    :disabled="$store.state.checkboxes.sporocila.value"
                    @change="$store.state.buttons.obvescanePosta.value = false, $store.state.buttons.obvescanePosta.error = false, checkFields()">
                  <span class="gdpr-radio-button" :class="{isInvalid: $store.state.buttons.obvescanePosta.error}"></span>
                </label>
              </div>
              <span class="btn-error-message" v-if="$store.state.buttons.obvescanePosta.error" v-html="$store.state.texts.channels.errorMsg"></span>
              <!-- NO CHANNELS ERROR MESSAGE -->
                  <p style="margin-left:15px" v-if="$store.state.checkboxes.sporocila.value" class="emailErrorMessage" v-html="$store.state.texts.checkboxErrors.sporocilaNo"></p>
            </div>
            <!-- DISCLOSURE TEXT -->
            <div>
              <div class="panel-group" id="accordion" role="tablist" aria-multiselectable="true">
                <div class="panel panel-default">
                  <div class="panel-heading consentDownArrow" style="position:relative" role="tab" id="headingOne">
                    <h4 class="panel-title">
                      <a role="button" data-toggle="collapse" v-html="$store.state.texts.disclosure.text1Title" @click="$store.state.DisclosureOneOpened = !$store.state.DisclosureOneOpened" data-parent="#accordion" aria-expanded="true" aria-controls="collapseOne">
                      </a>
                    </h4>
                  </div>
                  <div v-if="$store.state.DisclosureOneOpened" id="collapseOne" class="panel-collapse collapse in" role="tabpanel" aria-labelledby="headingOne">
                    <div class="panel-body">
                      <p v-html="$store.state.texts.disclosure.text1Bullet1"></p> 
                      <p v-html="$store.state.texts.disclosure.text1Bullet2"></p> 
                      <p v-html="$store.state.texts.disclosure.text1Bullet3"></p> 
                      <p v-html="$store.state.texts.disclosure.text1Bullet4"></p> 
                      <p v-html="$store.state.texts.disclosure.text1Bullet5"></p> 
                      <p v-html="$store.state.texts.disclosure.text1Bullet6"></p> 
                      <p v-html="$store.state.texts.disclosure.text1Bullet7"></p> 
                      <p v-html="$store.state.texts.disclosure.text1Bullet8"></p> 
                    </div>
                  </div>
                </div>
              </div>
              <p v-html="$store.state.texts.disclosure.textSubtitle"></p> 
            </div>
          </div>
          <!-- SUBMIT BUTTON -->
          <div id="gdpr-submit-button">
            <button v-html="$store.state.texts.gdpr.gdprBtn" class="btn btn-lg btn-primary" type="submit" @click.prevent="touchAll(), validateBtns(), validation(), submit()"></button>
          </div>
        </form>
      </div>
      <!-- FOOTER -->
      <div id="gdpr-footer">
        <p v-html="$store.state.texts.gdpr.gdprSmallPrint"></p>
      </div>
    </div>
</template>

<script>
import { required, email, minLength, maxLength } from "vuelidate/lib/validators";
import { mapState } from 'vuex'
import $ from 'jquery'

export default {
  data () {
    return {
    }
  },
  computed: mapState([
    'ime',
    'priimek',
    'email',
    'street',
    'postOffice',
    'postNumber',
    'telephone'
  ]),
  validations: {
    ime: {
      required,
    },
    priimek: {
      required,
    },
    email: {
      required,
      email
    },
    street: {
      required
    },
    postOffice: {
      required
    },
    postNumber: {
      required,
      minLength: minLength(4),
      maxLength: maxLength(5)
    },
    telephone: {
      required,
      minLength: minLength(9),
      maxLength: maxLength(13)
    }
  },
  beforeCreate() {
    this.$set(this.$store.state, 'ime',  '')
    this.$store.state.priimek = ''
    if (this.$route.query.name) {
      this.$store.state.ime = this.$route.query.name
    }
    if (this.$route.query.lastName) {
      this.$store.state.priimek = this.$route.query.lastName
    }
    if ((this.$route.query.subid || this.$route.query.subnlid) && this.$route.query.key) {
      this.$store.state.form.user.id = this.$route.query.subid || this.$route.query.subnlid;
      this.$store.state.form.user.key = this.$route.query.key
      this.$http.get('/backend/api/v1/subid/' + this.$store.state.form.user.id + '/key/' + this.$store.state.form.user.key).then( (response) => {
        console.log(response.body)
        if (response.body) {
          if (response.body.user) {
            if (response.body.user.ime) {
              this.$store.state.ime = response.body.user.ime
            }
            if (response.body.user.priimek) {
              this.$store.state.priimek = response.body.user.priimek
            }
            if (response.body.user.email) {
              this.$store.state.email = response.body.user.email
            }
            if (response.body.user.street) {
              this.$store.state.street = response.body.user.street
            }
            if (response.body.user.title) {
              this.$store.state.title = response.body.user.title
              this.$store.state.form.user.title = response.body.user.title
              this.$store.state.dropdowns.gender.validation = true
            }
            if (response.body.user.postOffice) {
              this.$store.state.postOffice = response.body.user.postOffice
            }
            if (response.body.user.postNumber) {
              this.$store.state.postNumber = response.body.user.postNumber
            }
            if (response.body.user.telephone) {
              this.$store.state.telephone = response.body.user.telephone
            }
          }

          if (response.body.gdpr) {
            if (response.body.gdpr.ponudbaNakup === true || response.body.gdpr.ponudbaNakup === false) {
              this.$store.state.form.gdpr.ponudbaNakup = response.body.gdpr.ponudbaNakup
              this.$store.state.buttons.ponudbaNakupBtn.value = response.body.gdpr.ponudbaNakup
              this.$store.state.buttons.ponudbaNakupBtn.error = false
            }
            if (response.body.gdpr.personalizacija === true || response.body.gdpr.personalizacija === false) {
              this.$store.state.form.gdpr.personalizacija = response.body.gdpr.personalizacija
              this.$store.state.buttons.personalizacijaBtn.value = response.body.gdpr.personalizacija
              this.$store.state.buttons.personalizacijaBtn.error = false
            }

            if (response.body.gdpr.ePosta) {
              this.$store.state.checkboxes.ePosta.value = response.body.gdpr.ePosta
              this.$store.state.form.gdpr.ePosta = response.body.gdpr.ePosta
              this.checkCheckBoxes()
            }
            if (response.body.gdpr.sms) {
              this.$store.state.checkboxes.sms.value = response.body.gdpr.sms
              this.$store.state.form.gdpr.sms = response.body.gdpr.sms
              this.checkCheckBoxes()
            }
            if (response.body.gdpr.telefon) {
              this.$store.state.checkboxes.telefon.value = response.body.gdpr.telefon
              this.$store.state.form.gdpr.telefon = response.body.gdpr.telefon
              this.checkCheckBoxes()
            }
            if (response.body.gdpr.posta) {
              this.$store.state.checkboxes.posta.value = response.body.gdpr.posta
              this.$store.state.form.gdpr.posta = response.body.gdpr.posta
              this.checkCheckBoxes()
            }
          }
        }
      })
    }
  },
  methods:{
    checkSporocila() {
      this.validation();
      if (this.$store.state.checkboxes.sporocila.value) {
        this.$store.state.form.gdpr.obvescanjeEposta = false;
        this.$store.state.form.gdpr.obvescanjeSMS = false;
        this.$store.state.form.gdpr.obvescanjeTelefon = false;
        this.$store.state.form.gdpr.obvescanePosta = false;
        this.$store.state.buttons.obvescanjeEposta.value = false;
        this.$store.state.buttons.obvescanjeEposta.error = false;
        this.$store.state.buttons.obvescanjeSMS.value = false;
        this.$store.state.buttons.obvescanjeSMS.error = false;
        this.$store.state.buttons.obvescanjeTelefon.value = false;
        this.$store.state.buttons.obvescanjeTelefon.error = false;
        this.$store.state.buttons.obvescanePosta.value = false;
        this.$store.state.buttons.obvescanePosta.error = false;
      } else {
        this.$store.state.form.gdpr.obvescanjeEposta = '';
        this.$store.state.form.gdpr.obvescanjeSMS = '';
        this.$store.state.form.gdpr.obvescanjeTelefon = '';
        this.$store.state.form.gdpr.obvescanePosta = '';
        this.$store.state.buttons.obvescanjeEposta.value = null;
        this.$store.state.buttons.obvescanjeEposta.error = false;
        this.$store.state.buttons.obvescanjeSMS.value = null;
        this.$store.state.buttons.obvescanjeSMS.error = false;
        this.$store.state.buttons.obvescanjeTelefon.value = null;
        this.$store.state.buttons.obvescanjeTelefon.error = false;
        this.$store.state.buttons.obvescanePosta.value = null;
        this.$store.state.buttons.obvescanePosta.error = false;

      }
    },
    touchAll() {
      this.$v.ime.$touch();
      this.$v.priimek.$touch();
      this.$v.postNumber.$touch();
      this.$v.street.$touch();
      this.$v.postOffice.$touch();
    },
    scrollTop () {
      setTimeout(() => {
        if ($('.error, .isInvalid').length) {
          $('html, body').animate({
            scrollTop: $('.error, .isInvalid').first().offset().top - 200
          }, 600)
        }
      }, 100)
    },
    checkCheckBoxes() {
      this.$store.state.checkboxValidation = true
    },
    checkFields() {
      return true;
    },
    /* Name and Lastname validations */
    nameLastNameValidation() {
      this.validatePhone();
      this.validateSms();
      this.validateStreet();
      this.validatePostOffice();
      this.validatePostNumber();
      this.validateEmail();
      if(!this.$v.ime.$invalid && 
        !this.$v.priimek.$invalid &&
        !this.$v.street.$invalid &&
        !this.$v.postNumber.$invalid &&
        !this.$v.postOffice.$invalid &&
        !this.$store.state.emailError &&
        this.$store.state.form.user.title !== '') {
        this.$store.state.form.user.ime = this.$store.state.ime
        this.$store.state.form.user.priimek = this.$store.state.priimek
        this.$store.state.form.user.street = this.$store.state.street
        this.$store.state.form.user.postNumber = this.$store.state.postNumber
        this.$store.state.form.user.postOffice = this.$store.state.postOffice
        this.$store.state.form.user.email = this.$store.state.email
        return true
      } else {
        return false
      }
    },
    /******************** 
      field validations
    *********************/
    fieldValidation(btnValue, valObj) {
      if(btnValue === false) {
        valObj = true;
        return true;
      } else {
        valObj = false;
        return false;
      }
    },
    validation() {
      if (
        this.fieldValidation(
          this.$store.state.buttons.obvescanjeEposta.error, this.$store.state.allValidations.obvescanjeEposta) &&
        this.fieldValidation(
          this.$store.state.buttons.obvescanjeSMS.error, this.$store.state.allValidations.obvescanjeSMS) &&
        this.fieldValidation(
          this.$store.state.buttons.obvescanjeTelefon.error, this.$store.state.allValidations.obvescanjeTelefon) &&
        this.fieldValidation(
          this.$store.state.buttons.obvescanePosta.error, this.$store.state.allValidations.obvescanePosta) &&
        this.nameLastNameValidation() &&
        !this.$store.state.telephoneError &&
        !this.$store.state.smsError &&
        !this.$store.state.ulicaError &&
        !this.$store.state.postaError &&
        !this.$store.state.postnaStError
      ){
        return true
      } else {
        return false;
      }
    },
    submit() {
      this.$store.state.form.user.brand = "Nissan";
      this.$store.state.submitted = true;
      if (this.validation() &&
          this.$store.state.buttons.obvescanjeEposta.value === false &&
          this.$store.state.buttons.obvescanjeSMS.value === false &&
          this.$store.state.buttons.obvescanjeTelefon.value === false &&
          this.$store.state.buttons.obvescanePosta.value === false) {
        this.$router.push({ name: 'Unsubscribe' })
        if (this.$store.state.uniqueKey) {
          this.$http.post('/backend/api/v1/countrycode/rs/key/' + this.$store.state.uniqueKey, this.$store.state.form).then(response => {
              console.log(response.status)
            }, error => {
              console.log(error)
            })
            } else {
          this.$http.post('/backend/api/v1/countrycode/rs/subid/' + this.$store.state.form.user.id + '/key/' + this.$store.state.form.user.key, this.$store.state.form).then(response => {
                console.log(response.status)
              }, error => {
                console.log(error)
              })
        }
      } else if (
          this.$store.state.buttons.obvescanjeEposta.value === null &&
          this.$store.state.buttons.obvescanjeSMS.value === null &&
          this.$store.state.buttons.obvescanjeTelefon.value === null &&
          this.$store.state.buttons.obvescanePosta.value === null) {
            this.$store.state.allChannelsNull = true;
      } else {
          if (this.validation()) {
            this.$router.push({ name: 'ThankYou' })
            if (this.$store.state.uniqueKey) {
              this.$http.post('/backend/api/v1/countrycode/rs/key/' + this.$store.state.uniqueKey, this.$store.state.form).then(response => {
              console.log(response.status)
            }, error => {
              console.log(error)
            })
          } else {
            this.$http.post('/backend/api/v1/countrycode/rs/subid/' + this.$store.state.form.user.id + '/key/' + this.$store.state.form.user.key, this.$store.state.form).then(response => {
                  console.log(response.status)
                }, error => {
                  console.log(error)
                })
            }
          } else {
            this.scrollTop()
          }
      }
    },
    //validate radio buttons
    validateBtns() {
      for(var key in this.$store.state.buttons) {
        if(this.$store.state.buttons[key].value === null){
          switch(key) {
            case "obvescanjeEposta":
              this.$store.state.buttons.obvescanjeEposta.error = true;
              break;
            case "obvescanjeSMS":
              this.$store.state.buttons.obvescanjeSMS.error = true;
              break;
            case "obvescanjeTelefon":
              this.$store.state.buttons.obvescanjeTelefon.error = true;
              break;
            case "obvescanePosta":
              this.$store.state.buttons.obvescanePosta.error = true;
              break;
          }
        }else {
          switch(key) {
            case "obvescanjeEposta":
              this.$store.state.buttons.obvescanjeEposta.error = false;
              break;
            case "obvescanjeSMS":
              this.$store.state.buttons.obvescanjeSMS.error = false;
              break;
            case "obvescanjeTelefon":
              this.$store.state.buttons.obvescanjeTelefon.error = false;
              break;
            case "obvescanePosta":
              this.$store.state.buttons.obvescanePosta.error = false;
              break;
          }
        }
      }
    },
    // Validation of telephone if sms or telephone checkboxes are checked
    /*validateSpecialFields(checkboxVal, vuelidateVal, errorMsg) {
      if (this.$store.state.checkboxes[checkboxVal].value === true && this.$v[vuelidateVal].$invalid) {
        this.$store.state[errorMsg] = true;
        this.$v[vuelidateVal].$touch();
        return false;
      } else {
        this.$store.state[errorMsg] = false;
        this.$store.state.form.user[vuelidateVal] = this.$store.state[vuelidateVal];
      }
       this.validateSpecialFields('sms', 'telephone', 'smsError') &&
        this.validateSpecialFields('telefon', 'telephone', 'telephoneError') &&
        this.validateSpecialFields('posta', 'street', 'ulicaError') &&
        this.validateSpecialFields('posta', 'postOffice',' postaError') &&
        this.validateSpecialFields('posta', 'postNumber', 'postnaStError')
    },*/
    validateSms() {
      if (this.$store.state.buttons.obvescanjeSMS.value === true && this.$v.telephone.$invalid) {
        this.$store.state.smsError = true;
        this.$v.telephone.$touch();
      } else {
        this.$store.state.smsError = false;
        this.$store.state.form.user.telephone = this.$store.state.telephone;
      }
    },
    validatePhone() {
      if (this.$store.state.buttons.obvescanjeTelefon.value === true && this.$v.telephone.$invalid) {
        this.$store.state.telephoneError = true;
        this.$v.telephone.$touch();
      } else {
        this.$store.state.telephoneError = false;
        this.$store.state.form.user.telephone = this.$store.state.telephone;
      }
    },
    validateStreet() {
      if(this.$store.state.buttons.obvescanePosta.value === true && this.$v.street.$invalid) {
        this.$store.state.ulicaError = true;
        this.$v.street.$touch();
      } else {
        this.$store.state.ulicaError = false;
        this.$store.state.form.user.street = this.$store.state.street;
      }
    },
    validatePostOffice() {
      if(this.$store.state.buttons.obvescanePosta.value === true && this.$v.postOffice.$invalid) {
        this.$store.state.postaError = true;
        this.$v.postOffice.$touch();
      } else {
        this.$store.state.postaError = false;
        this.$store.state.form.user.postOffice = this.$store.state.postOffice;
      }
    },
    validatePostNumber() {
      if(this.$store.state.buttons.obvescanePosta.value === true && this.$v.postNumber.$invalid) {
        this.$store.state.postnaStError = true;
        this.$v.postNumber.$touch();
      } else {
        this.$store.state.postnaStError = false;
        this.$store.state.form.user.postNumber = this.$store.state.postNumber;
      }
    },
    validateEmail() {
      if(this.$store.state.buttons.obvescanjeEposta.value === true && this.$v.email.$invalid) {
        this.$store.state.emailError = true;
        this.$v.email.$touch();
      } else {
        this.$store.state.emailError = false;
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  h4 {
    font-weight: bold
  }

  .panel-title > a {
    display: block;
  }
   // FORM BACKGROUND GLOW STYLING
  .form-control:focus {
    border-color: #c3002f;
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgba(0, 115, 172, 0.6);
  }
  .btn-primary {
    color: #fff;
    border-radius: none;
  }
  /* GENERAL STYLING */
  #gdpr-main-form-container {
    font-family: Nissan Regular, Arial, Verdana, sans-serif;
    margin:  50px 0;
  }
  #gdpr-main-text {
    font-family: Nissan Regular, Arial, Verdana, sans-serif;
  }
  .gdpr-color-text {
    color: #c3002f;
  }
  .container {
    margin: 50px auto;
  }
  body input[type="text"]{
    font-size: 14px;
    padding: 6px 12px;
  }
  body {
    font-family: Nissan Regular, Arial, Verdana, sans-serif;
  }
  .label-margin-top {
    margin-top: 5px;
  }
  .checkbox-margin-top {
    margin-top: 3px;
  }
  /* NAME INPUT */
  #gdpr-form-name {
    margin-top: 5%;
    margin-bottom: 5%;
  }
  .text-field {
      width: 50%;
  }
/*EMAIL INPUT*/
  #gdpr-email {
    font-family: Nissan Regular, arial, sans-serif;
  }  
  /* DROPDOWN STYLING */
  #user-gender {
    padding: 8px;
    border: 1px solid #999;
    position: relative;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    position:relative;
    cursor: pointer;
  }
  .consentDownArrow:after {
    font-family: icon-Nissan-Global;
    content: "\E610";
    top: 50%;
    right: 2%;
    position: absolute;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    font-style: normal;
    font-weight: 400;
    font-variant: normal;
    text-transform: none;
    line-height: 1;
    pointer-events: none;
    color: #999;
  }
  #user-gender::-ms-expand {
    display: none;
  }
  .custom-select:after {
    font-family: icon-Nissan-Global;
    content: "";
    position: absolute;
    top: 50%;
    left: 45%;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    font-style: normal;
    font-weight: 400;
    font-variant: normal;
    text-transform: none;
    line-height: 1;
    pointer-events: none;
    color: #999;
  }
  .selectedValue {
    font-family: Nissan Regular, Arial, Verdana, sans-serif; 
    color: #999;
    position: absolute;
    left: 28px;
    top: 11px;
  }
  /*OTHER INFORMATION */
  #gdpr-other-information {
    margin-top: 5%;
  }

  /* OPOMBA */
  #gdpr-opomba {
    color: #ccc;
  }

  //ERROR MESSAGE
  .error-message {
    color: red;
    margin-left: 27%;
  }
  .emailErrorMessage {
    color: red;
  }
  /* CUSTOM RADIO BUTTONS */
  .form-check {
    display: block;
    position: relative;
    padding-left: 35px;
    margin-bottom: 12px;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
  .form-check-label {
    cursor: pointer;
    text-transform: uppercase;
  }
  .form-check input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
  }
  .gdpr-radio-button {
    position: absolute;
    top: 0;
    left: 0;
    height: 25px;
    width: 25px;
    border: 1px solid #999;
  }
  .form-check:hover input ~ .gdpr-radio-button {
    border: 2px solid #c3002f;
  }
  .gdpr-radio-button:after {
    content: "";
    font-family: icon-Nissan-Global; 
    position: absolute;
    display: none;
    color: #c3002f;
  }
  .form-check input:checked ~ .gdpr-radio-button:after {
    display: block;
    left: 4px;
  }
  .form-check input:checked ~ .gdpr-radio-button {
    border: 2px solid #c3002f;
  }
  // CHECKBOX SECTION
  .checkbox-section {
    margin-top: 30px;
  }
  .gdpr-checkbox {
    position: absolute;
    top: 0;
    left: 0;
    height: 25px;
    width: 25px;
    border: 1px solid #999;
  }
  .gdpr-checkbox:after {
    content: "";
    font-family: icon-Nissan-Global;  
    position: absolute;
    display: none;
    color: #c3002f;
  }
  .form-check input:checked ~ .gdpr-checkbox:after {
    display: block;
    left: 4px;
  }
  .form-check input:checked ~ .gdpr-checkbox {
    border: 2px solid #c3002f;
  }
  .form-check:hover input ~ .gdpr-checkbox {
    border: 2px solid #c3002f;
  }
  #nacin-prejemanja {
    .form-check {
      padding-left: 35px;
    }
  }
  #e-posta-checkbox {
    right: 10px;
  }
  #sms-checkbox {
    right: 40px;
  }
  #telefon-checkbox {
    right: 5px;
  }
  #posta-checkbox {
    right: 0px;
  }

  // GDPR INFO ICON
  .gdpr-info-icon {
    padding: 1px 5px 5px 10px;
    margin-left: 10px;
    width: 25px;
    height: 25px;
    background-color: #CFC9C4;
    border-radius: 50%;
    color: #fff;
    z-index: 999;
  }
  .gdpr-info-icon:hover {
      background-color: #c3002f;
  }

  //CUSTOM TOOLTIP
  .custom-tooltip {
    display: inline-block;
  }

  .custom-tooltip .tooltip-text {
    position:relative;
    visibility: hidden;
    width: 50%;
    background-color: #fff;
    color: #000;
    border: 1px solid #c3002f;
    text-align: center;
    border-radius: 6px;
    padding: 30px;
    margin-left: 20px;
    font-weight: 300;

    /* Position the tooltip */
    z-index: 9999;
    position: absolute;
  }

  .custom-tooltip:hover .tooltip-text {
    visibility: visible;
    opacity: 1;
  }

  /* SMALL PRINT */
  #gdpr-small-print {
    margin-top: 5%;
  }

  /* SUBMIT BUTTON */
  #gdpr-submit-button{
    text-align: center;
    margin: 10% 0 3% 0;
    button {
      background-color: #c3002f;
      border-color: #c3002f;
      padding: 10px 85px;
      border-radius: 25px;
      position: relative;
      font-family: Nissan Regular,Helvetica,Arial,sans-serif; 
    }
    button:hover {
      background-color: #0b4a7e;
      border-color: #0b4a7e;
    }
    button:after{
      font-size: 20px;
      position: absolute;
      top: 35%;
      margin-top: -.3333333333em;
      right: 30px;
      content: ">";
    }
  }

  /* ERROR STYLING */
  .isInvalid {
    border: 2px solid red!important;
  }
  /*input.isInvalid::placeholder {
    color: red;
  }*/
  .btn-error-message {
    color: red;
    position: relative;
    left: 67%;
  }
  .email-error-message {
    color: red;
    position: relative;
    left: 20%;
  }

  /* NAVBAR OVERRIDE STYLING */
  .nav-root.upgraded {
    overflow: hidden;
  }
  .col-form-label {
      font-weight: normal;
    }

  .col-form-label-first-channels {
      font-weight: normal;
      font-size: 15px;
    }
  p {
    font-size: 14px;
    line-height: 1.4;
  }

  /* RESPONSIVE STYLING */
  @media only screen and (max-width: 768px) {
    .form-check {
      margin: 20px 0 20px 15px;
    }
    .col-form-label {
      margin: 10px 0;
    }
    .form-control {
      margin: 20px 0;
    }
    #gdpr-submit-button {
      margin: 40px 0;
    }
    .btn-error-message {
      left: 2%;
    }
    .error-message {
      margin-left: 13%;
    }
    .text-field {
      width: 50%;
    }
    .custom-select:after {
      left: 45%;
    }
    .form-control::-moz-placeholder {
      color: #000;
    }
    .custom-tooltip {
      #ponudbaNakup-tooltip {
         width: 100%;
      }
      #ponudbaPoprodajni-tooltip {
        width: 75%;
        top: -50px;
      }
      #personalizacija-tooltip {
        width: 100%;
        top: -200px;
      }
      #enovice-tooltip {
        width: 100%;
        top: -200px;
      }
    }
  }
  @media only screen and (max-width : 480px) {
    .custom-tooltip {
      #ponudbaNakup-tooltip {
        width: 100%;
        left: 0;
        top: -150px;
      }
      #ponudbaPoprodajni-tooltip {
        width: 75%;
        top: -200px;
        left: 0;
      }
      #personalizacija-tooltip {
        width: 130%;
        top: -370px;
        left: 0px;
      }
      #enovice-tooltip {
        width: 130%;
        top: -170px;
        left: 0px;
      }
    }
    .text-field {
        width: 100%;
    }
    .custom-select:after {
      left: 89%;
    }
    .error-message {
      margin-left: 5%;
    }
    #user-gender {
      margin: 20px 0;
    }
    .selectedValue {
      top: 30px;
      color: #000;
    }
  }
  @media only screen and (max-width : 320px) {
    .custom-tooltip {
      #personalizacija-tooltip {
        width: 110%;
        top: -450px;
        left: 0px;
      }
    }
    #gdpr-ime,
    #gdpr-priimek,
    #gdpr-email {
      width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Form.vue